import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import classnames from 'classnames';
import queryString from 'query-string';

import { GlamboxCookieStore } from 'core/glambox/GlamboxCookieStore';
import { TokenActions } from 'state/actions/user/TokenActions';
import { UiActions } from 'state/actions/UiActions';
import { StateActions } from 'state/actions/StateActions';
import { Routes } from 'Routes';
import { Menu } from 'components/menu/Menu';
import { Modal } from 'components/modal/Modal';
import { SubscriberModals } from 'components/general/SubscriberModals';
import { GlamboxLocalStore } from 'core/glambox/GlamboxLocalStore';
import { GlamboxRecaptcha } from 'core/glambox/GlamboxRecaptcha';
import { GlamboxSessionStore } from 'core/glambox/GlamboxSessionStore';
import { Modals } from 'components/general/Modals';

class App extends Component {
  /**
   * @type {GlamboxLocalStore}
   */
  storeHandler = null;

  // --------------------------------------------------------------------

  constructor(props) {
    super(props);

    this.storeHandler = new GlamboxLocalStore();

    GlamboxRecaptcha.addListener(this._recaptchaSet);

    this.state = {
      modal: false,
    };
  }

  componentDidMount() {
    const { location, history } = this.props;

    let qs = queryString.parse(location.search);

    let localStore = new GlamboxLocalStore();
    localStore.set(
      'utm_campaign',
      localStore.get('utm_campaign') || qs['utm_campaign']
    );
    localStore.set(
      'utm_source',
      localStore.get('utm_source') || qs['utm_source']
    );
    localStore.set(
      'utm_medium',
      localStore.get('utm_medium') || qs['utm_medium']
    );
    localStore.set(
      'utm_content',
      localStore.get('utm_content') || qs['utm_content']
    );

    this.props.alertsClear();
    this.props.resetUiState();

    // Verifica se tem token no boot
    this.checkTokenOnBoot();

    let referrer = document.referrer,
      refCheck = /glampartners?\.com\.br/gi.test(referrer),
      sessionStore = new GlamboxSessionStore();
    if (refCheck === true) {
      sessionStore.set('isGlampartner', true);
      history.push('/glampartner');
    } else {
      if (/^\/glampartner/g.test(location.pathname)) {
        sessionStore.set('isGlampartner', true);
      } else {
        sessionStore.set('isGlampartner', false);
      }
    }

    this.resize();
    window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  componentDidUpdate(prevProps, prevState) {
    let localStore = new GlamboxLocalStore();

    if (this.storeHandler.get('userCheckFlag')) {
      let statusRegister = this.storeHandler.get('userJustRegistered');

      let hostname = window.location.hostname;
      if (!/(b4a\.net\.br|localhost)/g.test(hostname)) {
        if (statusRegister === true) {
          window.dataLayer.push({
            event: 'minha.glambox.userRegistration',
            'gtm.elementClasses': 'userRegistration',
            'gtm.elementId': 'userRegistration',
          });
        } else {
          window.dataLayer.push({
            event: 'minha.glambox.userLogin',
            'gtm.elementClasses': 'userLogin',
            'gtm.elementId': 'userLogin',
          });
        }
      }

      this.storeHandler.set('userCheckFlag', null);
      this.storeHandler.set('userJustRegistered', null);
    }
  }

  render() {
    const { props, state } = this;
    const { ui } = props;

    let _cls = [];
    if (ui.notifs.visible === true || ui.menu.visible === true) {
      _cls.push('blur');
    }

    if (!this.isLoggedIn()) {
      return <Switch>{this.renderRoutes()}</Switch>;
    }

    if (!this.bulkDataStatus()) return null;

    return (
      <div id={'gb-minha'} className={classnames(_cls)}>
        {/* MENU */}
        <Menu />

        {/* VIEWS */}
        <div id={'gb-contents'}>
          <Switch>{this.renderRoutes()}</Switch>
        </div>

        {/* MODAIS */}
        <Modals />
        <SubscriberModals />
      </div>
    );
  }

  // --------------------------------------------------------------------

  _recaptchaRenew = () => {
    this.props.recaptchaRequest(true);
    GlamboxRecaptcha.execute();
  };

  _recaptchaSet = recaptcha => {
    if (recaptcha) {
      //console.log(`> RECAPTCHA: ${recaptcha}`);
      this.props.recaptchaSet(recaptcha);
      this.props.recaptchaRequest(false);
    }
  };

  _recaptchaUnset = () => {
    this.props.recaptchaUnset();
    this.props.recaptchaRequest(false);
  };

  _recaptchaRequest = status => {
    this.props.recaptchaRequest(status);
  };

  bulkDataStatus = () => {
    const { person, subscribers, editions, rewards, beautyProfile } =
      this.props;

    return (
      person !== null &&
      subscribers !== null &&
      editions !== null &&
      rewards !== null &&
      beautyProfile !== null
    );
  };

  checkTokenOnBoot = () => {
    const { token } = this.props;

    const tokenData = token.data;

    if (tokenData === null) {
      let cookieHandle = new GlamboxCookieStore(
        '/',
        process.env.REACT_APP_GB_COOKIE_ROOT,
        false,
        new Date(Date.now() + 60 * 60 * 3 * 1000)
      );

      let authorization = cookieHandle.get('gbAuthorization'),
        personId = cookieHandle.get('gbPersonId');

      if (authorization && personId) {
        this.props.identifyTokenAndPersonId(authorization, personId);
      }
    } else {
      let shouldSync = Date.now() - 1594830277751 > 3600000;

      if (token && shouldSync && !this.bulkDataStatus()) {
        this.props.identifyTokenAndPersonId(
          token.Authorization,
          token.personId
        );
      }
    }
  };

  isLoggedIn = () => {
    const { token } = this.props;
    return token.data !== null;
  };

  renderRoutes = () => {
    let RoutesData = this.isLoggedIn() ? Routes.auth : Routes.open;

    return RoutesData.map((item, key) => {
      item.key = key;

      return <Route {...item} />;
    });
  };

  resize = () => {
    const { props } = this;

    if (window.innerWidth <= 991 && props.ui.mobile === false) {
      props.isMobile(true);
    } else if (window.innerWidth >= 992 && props.ui.mobile) {
      props.isMobile(false);

      if (props.ui.menu.visible) props.menuHide();
    }
  };
}

const mapStateToProps = state => {
  return {
    ui: state.ui,
    token: state.token,
    person: state.person.data,
    subscribers: state.subscribers.data,
    editions: state.editions.data,
    notifs: state.notifs.data,
    partnerInfo: state.partnerInfo.data,
    partnerGeneral: state.partnerGeneral.data,
    partnerSales: state.partnerSales.data,
    rewards: state.rewards.data,
    beautyProfile: state.beautyProfile.data,
  };
};

const mapDispatchToProps = dispatch => ({
  recaptchaSet: recaptcha => {
    dispatch(UiActions.recaptchaSet(recaptcha));
  },

  recaptchaUnset: () => {
    dispatch(UiActions.recaptchaUnset());
  },

  recaptchaRequest: status => {
    dispatch(UiActions.recaptchaRequest(status === true));
  },

  alertsClear: () => {
    dispatch(UiActions.alertClear());
  },

  isMobile: isMobile => {
    dispatch(UiActions.mobileSet(isMobile === true));
  },

  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },

  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },

  login: (email, password) => {
    dispatch(TokenActions.login(email, password));
  },

  loginWithToken: token => {
    dispatch(TokenActions.loginWithToken(token));
  },

  identifyTokenAndPersonId: (token, personId) => {
    dispatch(TokenActions.identifyTokenAndPersonId(token, personId));
  },

  menuHide: () => {
    dispatch(UiActions.menuHide());
  },

  resetUiState: () => {
    dispatch(UiActions.resetState());
  },

  portalGlampartnersIsActive: isActive => {
    dispatch(StateActions.portalGlampartnersIsActive(isActive));
  },
});

App = connect(mapStateToProps, mapDispatchToProps)(App);

export { App };
